// InventoryHistory.js
import React from "react";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";

const InventoryHistory = ({ data }) => {
  const {
    stock = 0,
    amount = 0,
    purchaseTransactions = [],
    salesTransactions = [],
  } = data;

  const formatCurrency = (value) =>
    `₹${Number(value).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  const totalPurchase = purchaseTransactions.reduce(
    (sum, t) => sum + t.amount,
    0
  );
  const totalSales = salesTransactions.reduce((sum, t) => sum + t.amount, 0);

  return (
    <Container fluid>
      <Row className="my-4">
        <Col md={6} className="mb-2">
          <Card className="shadow-sm border-0">
            <Card.Body className="d-flex align-items-center justify-content-between bg-light rounded">
              <span className="fw-semibold text-secondary">Current Stock:</span>
              <Badge bg="success" className="px-3 py-2 rounded-pill">
                {stock}
              </Badge>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-2">
          <Card className="shadow-sm border-0">
            <Card.Body className="d-flex align-items-center justify-content-between bg-light rounded">
              <span className="fw-semibold text-secondary">Stock Amount:</span>
              <Badge bg="success" className="px-3 py-2 rounded-pill">
                {formatCurrency(amount)}
              </Badge>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-4">
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white fw-bold text-secondary border-bottom">
              Purchase Transactions
            </Card.Header>
            <Card.Body className="p-0">
              <div
                className="table-responsive"
                style={{ maxHeight: "250px", overflowY: "auto" }}
              >
                <Table hover size="sm" className="mb-0 align-middle">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th>DATE</th>
                      <th>QUANTITY</th>
                      <th>RATE</th>
                      <th>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseTransactions.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-3">
                          No purchase transactions
                        </td>
                      </tr>
                    ) : (
                      purchaseTransactions.map((t, i) => (
                        <tr key={i}>
                          <td>{t.date}</td>
                          <td>{t.quantity}</td>
                          <td>{formatCurrency(t.rate)}</td>
                          <td>{formatCurrency(t.amount)}</td>
                        </tr>
                      ))
                    )}
                    {purchaseTransactions.length > 0 && (
                      <tr className="fw-semibold table-light sticky-bottom bg-primary">
                        <td colSpan="3" className="text-end text-secondary">
                          Total Purchase:
                        </td>
                        <td className="fw-bold text-dark">
                          {formatCurrency(totalPurchase)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-4">
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white fw-bold text-secondary border-bottom">
              Sales Transactions
            </Card.Header>
            <Card.Body className="p-0">
              <div
                className="table-responsive"
                style={{ maxHeight: "250px", overflowY: "auto" }}
              >
                <Table hover size="sm" className="mb-0 align-middle">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th>DATE</th>
                      <th>QUANTITY</th>
                      <th>RATE</th>
                      <th>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salesTransactions.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-3">
                          No sales transactions
                        </td>
                      </tr>
                    ) : (
                      salesTransactions.map((t, i) => (
                        <tr key={i}>
                          <td>{t.date}</td>
                          <td>{t.quantity}</td>
                          <td>{formatCurrency(t.rate)}</td>
                          <td>{formatCurrency(t.amount)}</td>
                        </tr>
                      ))
                    )}
                    {salesTransactions.length > 0 && (
                      <tr className="fw-semibold table-light sticky-bottom bg-primary">
                        <td colSpan="3" className="text-end text-secondary">
                          Total Sales:
                        </td>
                        <td className="fw-bold text-dark">
                          {formatCurrency(totalSales)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default InventoryHistory;
